// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card{display:flex;flex-direction:column;width:100%}.card .card-title{margin-top:0;background:#fdfdfd}.card.narrow{max-width:400px}.card h1{margin-top:0}.card .card-body,.card .card-body form{display:flex;flex-direction:column}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
